import React from "react";
import {
    CardHeader,
    CardPriceSection,
    CardSubHeader,
    CardWrapper,
    FeaturedBadge, FeatureItem,
    FeatureList,
    HeaderWrapper
} from "./styled";

export const PricingCard = ({plan}) => {
    return (
        <CardWrapper $isFeatured={plan?.isFeatured}>
            {plan?.isFeatured && <FeaturedBadge>Featured</FeaturedBadge>}
            <HeaderWrapper $isFeatured={plan.isFeatured}>
                <CardHeader $isFeatured={plan.isFeatured}>
                    {plan.title}
                </CardHeader>

                <CardPriceSection $isFeatured={plan.isFeatured}>
                    <sup>{plan.currency || '€'}</sup>{plan.amount}
                </CardPriceSection>
            </HeaderWrapper>

            <FeatureList>
                <CardSubHeader>
                    {plan?.period_string}
                </CardSubHeader>
                {plan?.advantages && plan?.advantages?.map((advantage, index) => (
                    <FeatureItem key={index}>{advantage}</FeatureItem>
                ))}
            </FeatureList>
        </CardWrapper>
    );
}
